import Option from '@/components/form/types/Option.ts';
import { CANCELLED_RECORD_CLASS } from '@/components/table/_fieldDefinitions/_base/cancelledRecord.ts';
import { BookingListDto } from '@/features/dashboard/bookings/types/BookingListDto.ts';
import { ClientListDto } from '@/features/dashboard/clients/types/ClientListDto.ts';
import {
  bookingOptionLabel,
  bookingOptionText,
  clientOptionLabel,
  clientOptionText,
  isCancelledBookingRow,
  isCancelledClientRow,
} from '@/components/asyncSelect/entitySelects/entityOptionLabels.ts';

const struckOption = (
  value: string,
  text: string,
  name: string,
  cancelled: boolean,
): Option => ({
  value,
  name,
  label: cancelled ? (
    <span className={CANCELLED_RECORD_CLASS}>{text}</span>
  ) : (
    text
  ),
});

export const bookingOption = (item: BookingListDto): Option =>
  struckOption(
    item.id,
    bookingOptionText(item),
    bookingOptionLabel(item),
    isCancelledBookingRow(item),
  );

export const clientOption = (item: ClientListDto): Option =>
  struckOption(
    item.client.id,
    clientOptionText(item),
    clientOptionLabel(item),
    isCancelledClientRow(item),
  );
